import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute } from '@tanstack/react-router';
import { Gauge } from 'lucide-react';

export const Route = createFileRoute('/admin-console/advanced/indicators')({
    component: Indicators,
    staticData: {
        breadcrumb: { title: 'Indicators' },
        ui: {
            icon: Gauge,
            widthVariant: 'default',
            menuDescription: 'Compliance indicators',
        },
    },
    beforeLoad(): ShareableRouteContext {
        return { ui: { title: 'Indicators', subtitle: 'Tools for tracking and managing indicators.' } };
    },
});

function Indicators() {
    return (
        <PageController route={Route}>
            <Tabs
                items={[
                    { label: 'Complaints', to: '/admin-console/advanced/indicators/complaints' },
                    { label: 'Incidents', to: '/admin-console/advanced/indicators/incidents' },
                ]}
            />
        </PageController>
    );
}
